import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.css";
import SideBar from "./components/Common/components/Sidebar";
import BreadCrumb from "./components/Common/components/Breadcrumb";
import AdminLogin from "./components/Login/AdminLogin";
import Dashboard from "./components/Common/components/DashBoard"; // Dashboard Component
import Roles from "./components/Common/components/Roles";
import AllUserDetails from "./components/User Management/components/AllUserDetails";
import UserDetailedView from "./components/User Management/components/UserDetailedView";
import WaitingList from "./components/Common/components/WaitingList";
import VerificationList from "./components/Common/components/VerificatonList";
import ReportsTable from "./components/Common/components/ReportsTable";
import AllPostDetailsTable from "./components/Post Management/components/AllPostDetailsTable";
import RecipeDetailedPage from "./components/Post Management/components/RecipeDetailedPage";
import GeneralPostpage from "./components/Post Management/components/GeneralPostpage";
import Category from "./components/CategorySection/components/Category";
import Cookies from "js-cookie";
import { Navigate } from "react-router-dom";
const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="*" element={<Layout />} />
      </Routes>
    </Router>
  );
};

// Layout Component: Applies SideBar and BreadCrumb for non-login pages
const Layout = () => {
  const location = useLocation();

  // Function to check if the authToken exists in cookies
  const isAuthenticated = () => {
    const token = Cookies.get("authToken"); // Getting the token from cookies
    return !!token; // Return true if the token exists
  };

  // Define routes where we want to hide Sidebar and Breadcrumb (like login and userdetails pages)
  const hideSidebarBreadcrumb =
    location.pathname === "/" ||
    location.pathname.startsWith("/userdetails/") ||
    location.pathname.startsWith("/recipe/") ||
    location.pathname.startsWith("/general/") ||
    location.pathname === "/login";

  return (
    <div className="app">
      {/* Render BreadCrumb only if we don't want to hide it */}
      {!hideSidebarBreadcrumb && <BreadCrumb />}
      <div className="main-content flex-column-style">
        {/* Render SideBar only if we don't want to hide it */}
        {!hideSidebarBreadcrumb && <SideBar />}
        <Routes>
          {/* If the user is not authenticated, redirect to login */}
          <Route
            path="/"
            element={
              isAuthenticated() ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <AdminLogin />
              )
            }
          />
          <Route
            path="/dashboard"
            element={
              isAuthenticated() ? <Dashboard /> : <Navigate to="/" replace />
            }
          />
          <Route
            path="/user-details"
            element={
              isAuthenticated() ? <AllUserDetails /> : <Navigate to="/" />
            }
          />
          <Route
            path="/userdetails/:id"
            element={
              isAuthenticated() ? <UserDetailedView /> : <Navigate to="/" />
            }
          />
          <Route
            path="/roles"
            element={isAuthenticated() ? <Roles /> : <Navigate to="/" />}
          />
          <Route
            path="/waiting-list"
            element={isAuthenticated() ? <WaitingList /> : <Navigate to="/" />}
          />
          <Route
            path="/verification-list"
            element={
              isAuthenticated() ? <VerificationList /> : <Navigate to="/" />
            }
          />
          <Route
            path="/reports"
            element={isAuthenticated() ? <ReportsTable /> : <Navigate to="/" />}
          />
          <Route
            path="/post-management"
            element={
              isAuthenticated() ? <AllPostDetailsTable /> : <Navigate to="/" />
            }
          />
          <Route
            path="/recipe/:id"
            element={
              isAuthenticated() ? <RecipeDetailedPage /> : <Navigate to="/" />
            }
          />
          <Route
            path="/general/:id"
            element={
              isAuthenticated() ? <GeneralPostpage /> : <Navigate to="/" />
            }
          />
          <Route
            path="/category"
            element={isAuthenticated() ? <Category /> : <Navigate to="/" />}
          />
          {/* Catch-all for unexpected paths (redirects to login if no authToken) */}
          <Route path="*" element={<Navigate to="/login" />} />
          <Route path="/login" element={<AdminLogin />} />
        </Routes>
      </div>
    </div>
  );
};

export default App;
